<template>
    <div>
        <b-row no-gutters>
            <b-col md="4" cols="12" align-self="center" class="text-center">
                <b-row>
                    <b-col>
                        <b-form-radio-group
                            v-model="selected"
                            :options="options"
                            buttons
                            button-variant="outline-secondary"
                            class="mb-2"
                        ></b-form-radio-group>
                    </b-col>
                    <div class="w-100"></div>
                    <b-col class="text-center p-4">
                        <exteriorVehiculo
                            :isFront="isFront"
                            :isCarpeta="isCarpeta"
                            class="m-2"
                            v-if="selected === 'exterior'"
                        />
                        <interiorVehiculo
                            :isFront="isFront"
                            :isCarpeta="isCarpeta"
                            class="m-2"
                            v-if="selected === 'interior'"
                        />
                        <volanteVehiculo
                            :isFront="isFront"
                            :isCarpeta="isCarpeta"
                            class="m-2"
                            v-if="selected === 'consola'"
                        />
                    </b-col>
                </b-row>
            </b-col>
            <b-col md="8" cols="12">
                <h5 class="text-center" v-if="!chequeoData.title">
                    Seleccione una parte...
                </h5>
                <b-card v-if="chequeoData.title" header-tag="header" no-body>
                    <template #header>
                        <h6
                            class="mb-0  mt-0 font-weight-bold text-muted  text-left"
                        >
                            {{ chequeoData.title }} :
                            {{ chequeoData.selector || "No registra estado" }}
                        </h6>
                    </template>
                    <image-zoom
                        :regular="
                            chequeoData.photo
                                ? 'https://d16vbrqyk5474c.cloudfront.net/fit-in/400x320/' +
                                  chequeoData.photo
                                : null
                        "
                        :zoom="
                            chequeoData.photo
                                ? 'https://d16vbrqyk5474c.cloudfront.net/fit-in/400x320/' +
                                  chequeoData.photo
                                : null
                        "
                        img-class="img-inspeccion"
                        :zoom-amount="3"
                        hover-message="Pase el cursor para hacer zoom"
                        touch-message="Pase el cursor para hacer zoom"
                        alt="Inspección"
                    >
                    </image-zoom>
                    <!-- <b-card-img
                    @click="
                        saveImgModal(
                            'https://d16vbrqyk5474c.cloudfront.net/fit-in/400x320/' +
                                chequeoData.photo
                        )
                    "
                    :src="
                        chequeoData.photo
                            ? 'https://d16vbrqyk5474c.cloudfront.net/fit-in/400x320/' +
                              chequeoData.photo
                            : null
                    "
                    alt="Inspección Mecanica"
                    bottom
                    data-toggle="modal"
                    data-target="#imagen_carrusel"
                    :data-image="chequeoData.photo"
                ></b-card-img>  -->
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import exteriorVehiculo from "components/inspeccionSvg/exteriorVehiculo";
import interiorVehiculo from "components/inspeccionSvg/interiorVehiculo";
import volanteVehiculo from "components/inspeccionSvg/volanteVehiculo";
import modalImage from "./modalImagen";
import imageZoom from "vue-image-zoomer";

export default {
    props: {
        isFront: {
            type: Boolean,
            default: false
        },
        isCarpeta: {
            type: Boolean,
            default: false
        }
    },
    components: {
        exteriorVehiculo,
        interiorVehiculo,
        volanteVehiculo,
        imageZoom,
        modalImage
    },
    computed: {
        chequeoData() {
            if (this.isCarpeta) {
                return this.$store.state.adminventa_carpeta.chequeo_card;
            } else {
                return this.$store.state.proceso.chequeo_card;
            }
        },
        ...mapFields("fichaTecnica", ["fotos_modal"])
    },
    mounted() {
        this.$nextTick(() => {
            $("#imagen_carrusel").on("show.bs.modal", function(event) {
                var button = $(event.relatedTarget);
                var recipient = button.data("image");
                var modal = $(this);
                modal
                    .find(".image_zoom")
                    .attr(
                        "src",
                        "https://d16vbrqyk5474c.cloudfront.net/fit-in/400x320/" +
                            recipient
                    );
            });
        });
    },
    data() {
        return {
            selected: "exterior",
            options: [
                { text: "Exterior", value: "exterior" },
                { text: "Interior", value: "interior" },
                { text: "Consola", value: "consola" }
            ]
        };
    },
    methods: {
        saveImgModal(url) {
            this.fotos_modal = url;
        }
    }
};
</script>

<style lang="scss">
img.img-inspeccion {
    width: 100%;
}
.vh--flex {
    display: -webkit-box;
}
.vh--message-bottom {
    bottom: 20px;
    left: 20px;
}
</style>
